import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { entityLikeSchema, entityLikeSchemaStrict } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { AccountDimensionSettingFindInterface } from '@zaoblako/shared/modules/catalog/dtos/account-dimension-setting/account-dimension-setting-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { ContractFindInterface } from '@zaoblako/shared/modules/document/dtos/contract/contract-find.dto';
import type { WarehouseFindInterface } from '@zaoblako/shared/modules/catalog/dtos/warehouse/warehouse-find.dto';
import type { CostItemFindInterface } from '@zaoblako/shared/modules/catalog/dtos/cost-item/cost-item-find.dto';
import type { OtherFinancialFlowFindInterface } from '@zaoblako/shared/modules/catalog/dtos/other-financial-flow/other-financial-flow-find.dto';
import type { CashFlowItemFindInterface } from '@zaoblako/shared/modules/catalog/dtos/cash-flow-item/cash-flow-item-find.dto';

import * as yup from 'yup';

/** Direction balance sheet settings create/update request body - DTO signature */
export interface DirectionBalanceSheetSettingsFormInterface {
  /** Account dimension setting */
  setting: AccountDimensionSettingFindInterface;
  /** Counterparties for balance sheet */
  contragents: ContragentFindInterface[];
  /** Contracts for balance sheet */
  contracts: ContractFindInterface[];
  /** Warehouses for balance sheet */
  warehouses: WarehouseFindInterface[];
  /** Cost items for balance sheet */
  costItems: CostItemFindInterface[];
  /** Other financial flows for balance sheet */
  otherFinancialFlows: OtherFinancialFlowFindInterface[]
  /** Cash/flow items for balance sheet */
  cashFlowItems: CashFlowItemFindInterface[];
}

/** Direction balance sheet settings create/update request body - DTO schema */
export const DirectionBalanceSheetSettingsFormDto = SerdeDtoClass.create<DirectionBalanceSheetSettingsFormInterface>(
  CatalogDtosKeysEnum.DIRECTION_BALANCE_SHEET_SETTINGS_FORM_DTO,
  {
    setting: {
      label: 'Субконто',
      serializer: entityLikeSchemaStrict,
    },
    contragents: {
      label: 'Контрагенты',
      serializer: yup.array(entityLikeSchema),
    },
    contracts: {
      label: 'Договоры',
      serializer: yup.array(entityLikeSchema),
    },
    warehouses: {
      label: 'Склады',
      serializer: yup.array(entityLikeSchema),
    },
    costItems: {
      label: 'Статьи затрат',
      serializer: yup.array(entityLikeSchema),
    },
    otherFinancialFlows: {
      label: 'Прочие доходы и расходы',
      serializer: yup.array(entityLikeSchema),
    },
    cashFlowItems: {
      label: 'Статьи движения денежных средств',
      serializer: yup.array(entityLikeSchema),
    },
  },
);

